import i18next from "i18next";
import { initReactI18next } from "react-i18next";
// We can localize to any language and any number of languages.
const resources = {
  en: {
    translation: {
      app_name: "Grootbasket",
      userKey: "citizen",
      error: "Error",
      incorrectUser: "User or password incorrect",
      noResults: "No results",
      last7days: "Last 7 days",
      last15days: "Last 15 days",
      last30days: "Last 30 days",
      last60days: "Last 60 days",
      temperature: "Temperature",
      highTemperature: "High temperature",
      lowTemperature: "Low temperature",
      humidity: "Humidity",
      highHumidity: "High humidity",
      lowHumidity: "Low humidity",
      airQuality: "Air quality",
      gasSmoke: "Gas & Smoke",
      activity: "Activity",
      inactivity: "Inactivity",
      illuminance: "Illuminance",
      noise: "Noise",
      energy: "Energy",
      events: "Events",
      high: "High",
      medium: "Medium",
      low: "Low",
      severity: "Severity",      
      login: {
        title: "Log in to Dashboard",
        insertLogin: "Enter your username and password below",
        username: "Username",
        password: "Password",
        forgotPassword: "Forgot password?",
        login: "LOG IN",
      },
      sidebar: {
        monitoredHouses: "Monitored houses",
      },
      dashboard: {
        todayEvents: "Today's events",
        eventsStatus: "Events status",
        as: "As of",
        lowEvents: "Low severity events",
        mediumEvents: "Medium severity events",
        highEvents: "High severity events",
        registered: "Registered",
        inProgress: "In Progress",
        onHold: "On hold",
        cancelled: "Cancelled",
        transferred: "Transferred",
        timeframe: "Timeframe",
      },
      map: {
        selectIndicator: "Select indicator",
        selectSeverity: "Select severity",
        allHouses: "All houses",
        seeMoreDetails: "See more details of",
        seeMore: "See more",
        house: "house",
        date: "Open date",
        socialServices: "Trigger Social Services",
        status: "Status",
        eventSeverity: "Event Severity",
      },
    },
  },
  pt: {
    translation: {
      app_name: "",
    },
  },
};
i18next.use(initReactI18next).init({
  debug: true,
  resources,
  lng: "en",
  interpolation: {
    escapeValue: false,
  },
});
export default i18next;
